export default "__VITE_ASSET__ca445848__"